import React, { useState } from 'react';
import { usePermissions } from '../../hooks/usePermission';
import { PageHeader } from '../../components/ui/PageHeader.js';
import { TabNav } from '../../components/ui/TabNav.js';
import { ProductCatalogSection } from '../Settings/ProductCatalogSection';
import { ServicePackagesSection } from '../Settings/ServicePackagesSection';
import { ChecklistTemplatesSection } from '../Settings/ChecklistTemplatesSection';
import { CollaboratorTemplatesSection } from '../Settings/CollaboratorTemplatesSection';
import ContractTemplateSection from './ContractTemplateSection';

type TabId = 'prodotti' | 'pacchetti' | 'checklist' | 'collab' | 'contratto';

interface Tab { id: TabId; label: string }

const TABS: Tab[] = [
  { id: 'prodotti',  label: 'Catalogo Prodotti' },
  { id: 'pacchetti', label: 'Pacchetti Servizi' },
  { id: 'checklist', label: 'Template Checklist' },
  { id: 'collab',    label: 'Template Collaboratori' },
  { id: 'contratto', label: 'Template Contratto' },
];

export default function CatalogPage() {
  const { hasPermission } = usePermissions();
  const canPackagesView          = hasPermission('catalog.packages.view');
  const canChecklistView         = hasPermission('catalog.checklist.view');
  const canCollabTemplatesView   = hasPermission('catalog.collaborator-templates.view');
  const canContractsView         = hasPermission('catalog.contracts.view');

  const tabPermMap: Record<TabId, boolean> = {
    prodotti:  true,
    pacchetti: canPackagesView,
    checklist: canChecklistView,
    collab:    canCollabTemplatesView,
    contratto: canContractsView,
  };

  const visibleTabs = TABS.filter(t => tabPermMap[t.id] ?? true);
  const [activeTab, setActiveTab] = useState<TabId>(visibleTabs[0]?.id ?? 'prodotti');

  return (
    <div className="page-enter" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <PageHeader title="Catalogo" />
      <TabNav tabs={visibleTabs} active={activeTab} onChange={(id) => setActiveTab(id as TabId)} />

      {/* Tab content */}
      {activeTab === 'prodotti' && <ProductCatalogSection />}

      {activeTab === 'pacchetti' && canPackagesView && <ServicePackagesSection />}

      {activeTab === 'checklist' && canChecklistView && <ChecklistTemplatesSection />}

      {activeTab === 'collab' && canCollabTemplatesView && <CollaboratorTemplatesSection />}

      {activeTab === 'contratto' && canContractsView && <ContractTemplateSection />}
    </div>
  );
}
